import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { usePanelData } from '../../FinancialWorkspace/components/ResponsivePageWithPanel/dataProvider'
import { usePanel } from '../../FinancialWorkspace/components/ResponsivePageWithPanel/provider'
import { useHeaders } from '../../FinancialWorkspace/components/Table/hooks/useHeaders'
import { PanelData } from '../components/HistoryPanel'

export const useEmployeeCostHeaders = () => {
  const { open, setOpen } = usePanel()
  const { data, setData } = usePanelData<PanelData>()

  const onClick = (date: moment.Moment) => {
    setData({
      label: date.format('MMMM YYYY'),
      chartLabel: date.format('MMM YYYY'),
      endDate: date.endOf('month').format('YYYY-MM-DD'),
      startDate: date.startOf('month').format('YYYY-MM-DD'),
    })
    setOpen(true)
  }

  useUnsafeEffect(() => {
    if (!open) setData({ ...data, chartLabel: undefined })
  }, [open, setData])

  const headers = useHeaders(onClick)

  return { data, headers }
}
